"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FooterMain;
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("./link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("hr", null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/articles/terms/"
}, "Terms");
var _ref3 = /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/articles/privacy/"
}, "Privacy");
var _ref4 = /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/articles/participation-statement/"
}, "Participation Statement");
function FooterMain() {
  return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement("footer", {
    className: "hidden-print"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: "navbar navbar-nav"
  }, _ref2, _ref3, _ref4, /*#__PURE__*/_react.default.createElement("span", {
    className: "pull-xs-right nav-item nav-link"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "http://www.jepso.com",
    style: {
      color: '#bf0080'
    }
  }, "\xA9 JEPSO 2016")))));
}